import { Helmet } from "react-helmet-async";
import { BUSINESS } from "@/data/site";

export default function Seo({ title, description, path, schemas = [] }) {
    const url = `${BUSINESS.domain}${path}`;
    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={url} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={url} />
            {schemas.map((s, i) => (
                <script key={i} type="application/ld+json">{JSON.stringify(s)}</script>
            ))}
        </Helmet>
    );
}

export function breadcrumbSchema(items) {
    return {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: items.map((it, i) => ({
            "@type": "ListItem",
            position: i + 1,
            name: it.name,
            item: `${BUSINESS.domain}${it.path}`,
        })),
    };
}

export function serviceSchema(serviceType) {
    return {
        "@context": "https://schema.org",
        "@type": "Service",
        serviceType,
        provider: {
            "@type": "HomeAndConstructionBusiness",
            name: BUSINESS.name,
            telephone: "+1-321-475-2230",
            url: BUSINESS.domain,
        },
        areaServed: [
            { "@type": "AdministrativeArea", name: "Brevard County, Florida" },
            { "@type": "AdministrativeArea", name: "Seminole County, Florida" },
        ],
    };
}

export function faqSchema(faqs) {
    return {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
    };
}

export const WEBSITE_SCHEMA = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: BUSINESS.name,
    url: `${BUSINESS.domain}/`,
    publisher: {
        "@type": "Organization",
        name: BUSINESS.name,
        url: BUSINESS.domain,
        logo: `${BUSINESS.domain}/logo.png`,
    },
};

export const LOCAL_BUSINESS_SCHEMA = {
    "@context": "https://schema.org",
    "@type": "HomeAndConstructionBusiness",
    name: BUSINESS.name,
    url: BUSINESS.domain,
    telephone: "+1-321-475-2230",
    email: BUSINESS.email,
    image: `${BUSINESS.domain}/logo.png`,
    description: "Professional in-home appliance repair serving Brevard County and Seminole County, Florida. $155 service call waived with completed repair. 6-month warranty on completed repairs.",
    areaServed: [
        { "@type": "AdministrativeArea", name: "Brevard County, Florida" },
        { "@type": "AdministrativeArea", name: "Seminole County, Florida" },
    ],
};
